import React, {useEffect, useState} from "react";
import "./NewBlogs.scss";
import image1 from "../../../../assets/images/blog5.png";
import Image2 from "../../../../assets/images/blogImg2.png";
import Image3 from "../../../../assets/images/blogImg3.png";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
const Blog5 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);

  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">
          Weekly Market Outlook <br /> February 10, 2025
        </h2>
      </div>
      <div className="blogContentnew">
        <div className="subHeader">
          <p className="highlightedBoldText">Market Momentum, Macro Themes & Key Trades to Watch</p>
          <p>
            <span className="highlightedText">Markets are pushing forward, but risks are lurking.</span> The economy remains resilient, job numbers are strong, and the Fed is trying to keep a cool
            head. But inflation could throw a wrench in everything. Meanwhile, Powell and Bailey step into the spotlight this week, and traders are gearing up for key CPI and PPI data. Plus, gold is
            on a tear—will $3000 be a stepping stone or a ceiling?
          </p>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader pointersWrapper">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Key Market Themes</h2>

              <div className="themesPointer pointersSection">
                <h2 className="pointersText">1. Tariffs Back in Focus</h2>
                <p>
                  Trump’s decision to slap 25% tariffs on steel and aluminum imports could reignite trade war fears. But the real spook factor? Inflation creeping higher, triggering a bond yield surge
                  and a potential market sell-off. Traders aren’t buying into the tariff panic just yet—call it <span className="highlightedText">tariff fatigue</span>—but a reaction is inevitable if
                  inflation data surprises to the upside.
                </p>
              </div>
              <div className="themesPointer pointersSection">
                <h2 className="pointersText">2. BOE’s Dovish Pivot—Is It Real?</h2>
                <p>
                  Bailey & Co. got the clean break they needed to pivot from stagflation concerns. The consensus is a <span className="highlightedText">GDP downgrade from 0% to -0.1%</span> , which
                  could fuel further easing. The wildcard? The index of services. If it rebounds, inflation worries may stall rate cut momentum.
                </p>
              </div>

              <div className="themesPointer pointersSection">
                <h2 className="pointersText">3. Powell’s Senate Testimony—CPI Matters</h2>
                <p>
                  Powell takes center stage on Tuesday and Wednesday, just after fresh CPI data drops. The Fed chair previously pointed to <span className="highlightedText">shelter/rent costs </span>{" "}
                  cooling as a sign of broader disinflation. If Core CPI jumps to <span className="highlightedText">0.4% MoM (from 0.2%)</span> , expect a{" "}
                  <span className="highlightedText">bond market freakout</span> and hawkish questioning from Congress.
                </p>
              </div>

              <div className="themesPointer pointersSection">
                <h2 className="pointersText">4. Gold’s Relentless Climb—$3000 Inevitable?</h2>
                <p>
                  Gold’s explosive move past key resistance suggests that the short-lived wave 4 consolidation in November was exactly that—short. Now,
                  <span className="highlightedText"> wave 5 is extending, and bulls are eyeing $3000 </span>The futures chart shows shallow pullbacks and a continued series of five-wave impulses. The
                  metal tariffs are only adding fuel to the fire.
                </p>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={image1}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => setSelectedImage(image1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Technical & Sentiment Analysis</h2>

              <div className="technicalPointer pointersSection">
                <h2 className="pointersText">Equities—Are We Nesting?</h2>
                <p>
                  The calm in U.S. markets is deceptive. <span className="highlightedText">A downtrend wave 1, countertrend wave 2, and a pending wave 3 markdown could be forming. </span> Bulls want
                  to see another leg down finding support at the uptrend baseline. If not, we could see broader weakness.
                </p>
              </div>
              <div className="technicalPointer pointersSection">
                <h2 className="pointersText">Dollar Moves—A Risk-Off Signal?</h2>
                <p>
                  The dollar’s recent sell-off could mean one of two things: (1) risk-off is coming, or (2) it’s a precursor to a broader market shake-up. If bond yields spike, watch for a mixed
                  reaction—
                  <span className="highlightedText">gold up, dollar up, and equity markets rattled. </span>
                </p>
              </div>

              <div className="technicalPointer pointersSection ">
                <h2 className="pointersText">Meta’s Unstoppable Run—But Nasdaq Looks Weak</h2>
                <p>
                  Meta just notched <span className="highlightedText">15 straight green days</span> , but Nasdaq’s momentum looks<span className="highlightedText">shaky</span>. If we print a{" "}
                  <span className="highlightedText">lower low</span>, it could set up for a breakout move. The hedge fund flows back into tech are aggressive, but is it a real trend shift or just
                  unwinding shorts?
                </p>
              </div>
            </div>

            <div className="relatedImg">
              <img
                src={Image2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => setSelectedImage(Image2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Last Week’s Recap</h2>
              <div className="listOfRecap">
                <ul>
                  <li>
                    <span className="highlightedText">Michigan inflation expectations surged</span>—1Y jumped to 4.3% (from 3.3%), rattling rate cut bets.
                  </li>
                  <li>
                    <span className="highlightedText">NFP jobs report</span>—Headline miss (143k vs. 169k expected), but revisions added 80k, keeping things firm.
                  </li>
                  <li>
                    <span className="highlightedText">Atlanta GDPNow jumped</span> from 2.9% to 3.9%, but inventory buildup raises concerns about real demand.
                  </li>
                  <li>
                    <span className="highlightedText">Hedge funds pivoting to tech</span> , aggressively buying semis & software—are institutions next?
                  </li>
                </ul>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={Image3}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => setSelectedImage(Image3)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <p className="highlightedBoldText">The Week Ahead – Key Events to Watch</p>
          <div className="listOfKeyEvents pointersSection_keyEvents">
            <p className="highlightedText_header">Tuesday, Feb 11</p>
            <div className="listOfRecap">
              <ul>
                <li>
                  <span className="highlightedText">Powell Senate Testimony—</span>Market will hang on every word.
                </li>
                <li>
                  <span className="highlightedText">USD NFIB Small Business Optimism—</span>Will tariffs impact sentiment?
                </li>
                <li>
                  <span className="highlightedText">BP Earnings</span> —Activist investor stake shake-up.
                </li>
              </ul>
            </div>
          </div>
          <div className="listOfKeyEvents pointersSection_keyEvents">
            <p className="highlightedText_header">Wednesday, Feb 12</p>
            <div className="listOfRecap">
              <ul>
                <li>
                  <span className="highlightedText">USD CPI (Core +0.3% expected, risk of 0.4%)</span>—Massive market mover.
                </li>
                <li>
                  <span className="highlightedText">Powell House Testimony</span>—Will CPI force him to shift tone?
                </li>
                <li>
                  <span className="highlightedText">Alibaba, Cisco, Reddit Earnings</span> —Tech-heavy session.
                </li>
              </ul>
            </div>
          </div>
          <div className="listOfKeyEvents pointersSection_keyEvents">
            <p className="highlightedText_header">Thursday, Feb 13</p>
            <div className="listOfRecap">
              <ul>
                <li>
                  <span className="highlightedText">GBP GDP & Index of Services</span>—BOE cuts depend on this data.
                </li>
                <li>
                  <span className="highlightedText">USD PPI</span>—Are producer prices sneaking up?
                </li>
                <li>
                  <span className="highlightedText">Coinbase, Airbnb, Palo Alto Earnings</span>—Crypto and cybersecurity focus.
                </li>
              </ul>
            </div>
          </div>
          <div className="listOfKeyEvents pointersSection_keyEvents">
            <p className="highlightedText_header">Friday, Feb 14</p>
            <div className="listOfRecap">
              <ul>
                <li>
                  <span className="highlightedText">USD Retail Sales</span>—Consumer strength check.
                </li>
                <li>
                  <span className="highlightedText">USD Inventories & Atlanta GDPNow Update</span>—Real-time economic growth pulse.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedBoldText">Actionable Takeaways</p>
              <div className="takeAwaysList pointersSection">
                <div className="listOfRecap">
                  <ul>
                    <li>
                      <span className="highlightedText">Gold remains a top play</span>—Momentum is strong, but watch for a near-term consolidation before the next leg higher.
                    </li>
                    <li>
                      <span className="highlightedText">Watch Powell’s CPI reaction</span>—If inflation surprises higher, yields spike, and risk assets take a hit.
                    </li>
                    <li>
                      <span className="highlightedText">Tech traders—Nasdaq needs a LL setup</span>—If it prints a lower low, it could trigger a bigger breakout move.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="relatedImg">
              <img
                src={image1}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => setSelectedImage(image1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <p className="highlightedBoldText">🎯 Key Trades to Watch</p>
          <div className="listOfRecap pointersSection">
            <ul>
              <li>
                <span className="highlightedText">Long Gold on dips</span>—Shallow pullbacks suggest a continuation move higher.
              </li>
              <li>
                <span className="highlightedText">Short Nasdaq on a LL setup</span>—Momentum looks weak; a breakdown could fuel selling.
              </li>
              <li>
                <span className="highlightedText">Bullish on energy stocks</span>—BP’s activist-driven rally suggests sector-wide momentum.
              </li>
              <li className="highlightedText">
                Markets are at an inflection point, and this week’s data will determine whether risk assets keep running or hit a wall. Stay sharp, manage risk, and be ready for the next move!
              </li>
            </ul>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedText">
            Disclaimer: This article is for informational purposes only and should not be considered financial advice. Always conduct your own research before making investment decisions.
          </p>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </div>
  );
};

export default Blog5;
